export default "__VITE_ASSET__34acb245__"